import React, { useEffect, useState } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../services/httpService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import helpers from '../../services/helpers';
import Loader from '../parts/Loader';
 
export default function VendorModal ({is_show = false, setShow, handleSelect}){
    const [loading, setLoading] = useState(0);
    const [name, setName] = useState('');
    const [notice, setNotice] = useState('');
    const [vendor_list, setVendors] = useState([]);
    const [table_data, setTableData] = useState([]);
   
    useEffect(() => {

    }, []);
   
    useEffect(() => {
        if(is_show) {
            fetchData()
        }
    }, [is_show]);
   
    useEffect(() => {
        let table_items_lg = []
        let table_items_sm = []

        
        if (Object.keys(vendor_list).length > 0) {
            table_items_lg = Object.entries(vendor_list).map(([key, data]) => {

                return (<tr key={data.id} style={{fontSize: '15px'}}>
                            <td>{data.vendor_name}</td>
                            <td>{data.gender ? data.gender : '---'}</td>
                            <td>{data.email ? data.email : '---'}</td>
                            <td>---</td>
                            <td width={50}><button className='btn btn-sm btn-primary' type="button" onClick={(e) => onSelect(data)}>Select</button></td>
                        </tr>)
            })
            table_items_sm = Object.entries(vendor_list).map(([key, data]) => {
                return (<tr key={data.id} style={{fontSize: '15px'}}>
                            <td>
                                Name: {data.vendor_name}<br/>
                                Gender: {data.gender ? data.gender : '---'}<br/>
                                Email {data.email ? data.email : '---'}<br/>
                                Phone {data.phone_no ? data.phone_no : '---'}
                            </td>
                            <td width={50}><button className='btn btn-sm btn-primary' type="button" onClick={(e) => onSelect(data)}>Select</button></td>
                        </tr>)
            })
        }

        setTableData(
            <>
            <div className='d-none d-md-block'>
                <table className='table table-sm mb-0 mt-3'>{table_items_lg}</table>
            </div>
            <div className='d-block d-md-none'>
                <table className='table table-sm mb-0 mt-3'>{table_items_sm}</table>
            </div>
            </>
        )
    }, [vendor_list]);

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function onSelect(e){
        reset();
        setShow(0);
        handleSelect(e)
    }

    function inputChange(e) {
        let { value, name } = e.target;
        
        if(!value) {
            setNotice('Vendor field is required') 
        }

        if(value) setNotice('');

        setName(value);

        fetchData(e)
    }

    function fetchData(e) {
        setLoading(1)

        let filter = '?store_id='+helpers.getStoreID()

        if(name){
            filter += '&search='+name+'&'
            filter = filter.slice(0, -1)
        }

        const url = helpers.createUrl('V1/manage/vendor/list'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setNotice('')
                setVendors(res)
                setLoading(0)
            })
            .catch((err) => {
                reset()
                setLoading(0)
                setNotice(<div className="alert alert-danger mt-3 px-3 py-2 mb-0" role="alert">Unable to fetch data.</div>)
            }); 
    }

    function reset(){
        setName('')
        setVendors([])
        setTableData([])
        setNotice('')
    }

    return (
        <>
            <Modal show={is_show} size="lg">
                <Modal.Header>
                    <h5>Browse Vendor</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row"  style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <div className="col-12">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Enter Vendor Name" aria-label="Vendor Name" aria-describedby="basic-addon2" onChange={inputChange} autoFocus />
                                {/* <div className="input-group-append">
                                    <button className="btn btn-outline-primary" type="button" onClick={fetchData}>Search</button>
                                </div> */}
                            </div>
                            <span className='text-danger'>{notice}</span>

                        </div>
                    </div>

                    {table_data}
                </Modal.Body>
            </Modal>
        </>
    )
}